import React from 'react'
import _ from 'lodash';
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import Header from '../../Components/Modules/Includes/Header'
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { fetchAllSubscriptions, selectSubscription,resetSubscriptionPlan, toggleTncError ,setCompanySubscription, resetCompanySubscription,fetchLoginUserDetail,setSubscriptionUpdate,openSupportPopup,updateFromFreetrial} from '../../Actions'
import { connect } from 'react-redux'
import moment from 'moment';
import Plan from '../Modules/Subscription/Plan'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {injectStripe} from 'react-stripe-elements';
class SubscriptionPlan extends React.Component {

  constructor(props) {
    super(props);
    this.tnc = null;
    this.setTncRef = element => {
      this.tnc = element;
    };
    this.state={
      modalIsOpen: false,
      authCalled: false,
      popHeading: "",
      popupMessage: "",
      openPop: false
    }
    this.handlePlanClick = this.handlePlanClick.bind(this);
    this.updatePlanClick = this.updatePlanClick.bind(this);
    this.handleTncClick= this.handleTncClick.bind(this);
    this.openSupportPopup= this.openSupportPopup.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateFromFreetrial = this.updateFromFreetrial.bind(this);
  }
  openModal() {
    const tncText = this.tnc.state.switched ? '' : 'Please accept the Terms of Service.';
    this.props.setTncText(tncText);
    if(this.tnc.state.switched){
      this.setState({modalIsOpen: true});
    }
  }
  closeModal() {
    this.setState({
      modalIsOpen: false,
      popupMessage: ""
    });
  }
  openSupportPopup(){
    this.props.openSupportPopupSubscription();
  }
  componentDidMount() {
    this.props.fetchSubscriptionsRequest();
    // this._attemptCardAuthenticate();
  }
  componentWillUnmount(){
    this.props.resetSubscriptionPlan();
    this.props.setTncText('');
  }
  componentWillReceiveProps(nextProps) {
    const userDetail = nextProps.userDetail;
    const subscriptions = nextProps.subscriptionPlan;

    if (userDetail.subsuser && subscriptions.plans.subscription && !subscriptions.selected_subscription) {
      this.props.selectedSubscription(userDetail.subsuser.subscription_id);
    }

    if(subscriptions.subscription_updated){
      this.props.setSubscriptionUpdate(false);
      this.props.fetchLoginUserDetail();
    }
  }

  handlePlanClick(key,upgradeDowngradeText) {
    this.props.selectedSubscription(key,upgradeDowngradeText);
  }
  updateFromFreetrial(){
    this.props.updateFromFreetrial(this.props.userDetail.company._id);
  }
  // update plan
  updatePlanClick(event) {
    this.closeModal();
    const tncText = this.tnc.state.switched ? '' : 'Please accept the Terms of Service.';
    this.props.setTncText(tncText);
    if(this.tnc.state.switched){
      this.props.setCompanySubscription(
        this.props.userDetail.company._id,
        this.props.subscriptionPlan.selected_subscription
      );
    }
  }
  handleTncClick(event) {
    const tncText = event.target.checked ? '' : 'Please accept the Terms of Service.';
    this.props.setTncText(tncText);
  }

  _attemptCardAuthenticate = () => {
    this.setState({
      authCalled: true
    })
    let that  = this;
    this.props.subscriptionPlan.sca_data.setupIntent ?
    this.props.stripe
        .confirmCardSetup(this.props.subscriptionPlan.sca_data.payment_intent_client_secret)
        .then(function(result) {
            if(result.error){
                // console.log(result.error)
                that.setState({
                  popHeading: "Setup Failed",
                  popupMessage: result.error.message,
                  openPop: true,
                  authCalled: false
              });
                that.props.resetCompanySubscription();
                that.props.fetchLoginUserDetail();
            }else{
              that.setState({
                authCalled: false
              })
              that.props.resetCompanySubscription(true, that.props.subscriptionPlan.sca_data.message);
              that.props.fetchLoginUserDetail();
              // console.log(result)
            }
        }) :
    this.props.stripe
        .confirmCardPayment(this.props.subscriptionPlan.sca_data.payment_intent_client_secret)
        .then(function(result) {
            if(result.error){
                // console.log(result.error)
                if(!that.state.popupMessage){
                  that.setState({
                      popHeading: "Payment Failed",
                      popupMessage: result.error.message,
                      openPop: true,
                      // authCalled: false
                  });
                }
                that.setState({
                  authCalled: false
                })
                that.props.resetCompanySubscription();
                that.props.fetchLoginUserDetail();
            }else{
              that.setState({
                authCalled: false
              })
              that.props.resetCompanySubscription(true, that.props.subscriptionPlan.sca_data.message);
              that.props.fetchLoginUserDetail();
              // console.log(result)
            }
        });
  }

  _closeModal = ()=>{
    this.setState({
      popHeading: "",
      popupMessage: "",
      openPop: false
    })
  }

  render() {

    let monthlyPlans = '', YearlyPlans = '', subscription = [];
    let yearlyOrder =['Business Starter Yearly','Business Essential Yearly','Business Enterprise Yearly'];
    let monthlyOrder =['Business Starter Monthly','Business Essential Monthly','Business Enterprise Monthly'];
    let currentPlanId=this.props.currentuser.subsuser?this.props.currentuser.subsuser.subscription_id: '';
    let subs_created_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_created_date : null;
    let subs_end_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_end_date : null;
    let subs_amount = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_amount : 0;
    let subs_paid = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_paid : null;
    let subs_allowance = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_allowance : 0;
    var tril_ends_in=''
    let check = this.props.subscriptionPlan.free_trial_end;
    let plan =this.props.subscriptionPlan.plans.subscription;
    
    var timeDiff = Math.abs(new Date(subs_end_date).getTime() - new Date(subs_created_date).getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    var trial_period_days;
    if(plan){
      trial_period_days= diffDays
    }
    if(!check){
      if(subs_amount==null && trial_period_days){
          let startDate = moment(subs_created_date).add('days', trial_period_days);
          let timeEnd = moment(new Date());
          let diff = startDate.diff(timeEnd);
          let diffDuration = moment.duration(diff);
          tril_ends_in=diffDuration.days();
          var days= diffDuration.days();
          var months = diffDuration.months() > 0 ? diffDuration.months() + ' month ' : '';    
      }
    }
    // console.log("3d attempt here", this.props.subscriptionPlan.sca_data.requires_action, this.state.authCalled)
    if(this.props.subscriptionPlan.sca_data.requires_action == true && !this.state.authCalled){
      this._attemptCardAuthenticate();
    }

    if (this.props.subscriptionPlan.plans.subscription) {

      subscription = this.props.subscriptionPlan.plans.subscription;

      let monthly = subscription.filter(subs => (subs.duration_type === 'MONTHLY'));

      let yearly = subscription.filter(subs => (subs.duration_type === 'YEARLY'));
      yearly = _.sortBy(yearly,(t) => {
        return _.indexOf(yearlyOrder, t.label);
      });
      
      monthly = _.sortBy(monthly,(t) => {
        return _.indexOf(monthlyOrder, t.label);
      });
      monthlyPlans = monthly.map((plan) => {

        return (
          <Plan key={plan._id} selectedPlan={this.props.subscriptionPlan} isCurrentPlan={currentPlanId=== plan._id}  isSelected={this.props.subscriptionPlan.selected_subscription === plan._id} plan={plan} taxes={this.props.subscriptionPlan.plans.taxes} planClick={this.handlePlanClick} />
        )
      });

      YearlyPlans = yearly.map((plan, index) => {
        //const subscriptionClass = (this.props.subscriptionPlan.selected_subscription === plan._id) ? 'subscription-box selected' : 'subscription-box';
        return (
          <Plan key={plan._id} selectedPlan={this.props.subscriptionPlan} isCurrentPlan={currentPlanId=== plan._id}  isSelected={this.props.subscriptionPlan.selected_subscription === plan._id} plan={plan} taxes={this.props.subscriptionPlan.plans.taxes} planClick={this.handlePlanClick} />
        )
      });

    }


    let selectedPlan = '';
    if (this.props.subscriptionPlan.selected_subscription) {
      const selectedPlanDetail = this.props.subscriptionPlan.plans.subscription.filter((subscription) => (subscription._id === this.props.subscriptionPlan.selected_subscription));

      let base_price = selectedPlanDetail[0].price;

      let base_price_thousand_place=base_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); 

      let taxApplied = 0;

      this.props.subscriptionPlan.plans.taxes.forEach((tax) => {
        taxApplied += parseFloat(base_price * tax.percentage / 100);
      });
      let taxAppliedThousandPlace=taxApplied.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //converted to thousand place

      let total_amout_inc_vat= 0;
      total_amout_inc_vat=(base_price+taxApplied).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //converted to thousand place
      let updateSubscButtonToggle = false;

      if (this.props.userDetail.subsuser) {
        updateSubscButtonToggle = (this.props.userDetail.subsuser.subscription_id === this.props.subscriptionPlan.selected_subscription);
        if(this.props.subscriptionPlan.updated_plan){
          updateSubscButtonToggle = (this.props.subscriptionPlan.updated_plan === this.props.subscriptionPlan.selected_subscription);
        }
      }
      if(this.props.subscriptionPlan.upgradeRequesting){
        updateSubscButtonToggle = true
      }
      selectedPlan = (
        <div className="plan-summary-box">
          <table className="plan-price-table margb15px">
            <tbody>
              <tr>
                <td width="80%">
                  <p>{selectedPlanDetail[0].label} Plan License :</p>
                  <label>{selectedPlanDetail[0].duration_type === 'YEARLY'?'You are saving 15% with this plan.':''}</label>
                </td>
                <td width="20%" className="text-right">
                  <p className="price">&pound; {base_price_thousand_place}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <table className="plan-price-table border-line">
            <tbody>
              <tr>
                <td width="70%">
                  <p>VAT :</p>
                </td>
                <td width="30%" className="text-right">
                  <p className="price">&pound; {taxAppliedThousandPlace}</p>
                </td>
              </tr>
              <tr>
                <td width="70%">
                  <p>Total :</p>
                </td>
                <td width="30%" className="text-right">
                  <p className="price">&pound; {total_amout_inc_vat}</p>
                </td>
              </tr>
            </tbody>
          </table>
          {!updateSubscButtonToggle &&
            <div className="terms-conditions">
              <Checkbox onClick={this.handleTncClick} ref={this.setTncRef} className="terms-check" /> <label>I accept the <a href="http://www.dokkit.co.uk/termsofservice" target='_blank'>Terms of Service. </a></label>
            </div>
          }

          <div className="update-plan">
            <RaisedButton
              label="Update Plan"
              type="submit"
              labelColor="#fff"
              labelStyle={{ 'fontWeight': '600' }}
              fullWidth={true}
              onClick={this.openModal}
              disabled={updateSubscButtonToggle}
            />
            <span>{this.props.subscriptionPlan.tnc_text}</span>
          </div>
        </div>
      );
    }
    const action = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeModal}
          />,
          <RaisedButton
            label="Ok"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.updatePlanClick}
          />
        ];
    return (<div>
      <Header />
      <div className="dashboard-page subscription-plan">
        <div className="right-content-dashboard active-dashboard">
          <div className="dashboard-content-sec table-dashboard margb25px">
            <h2 className="subs-head"><Link to="/company"><MdArrowBack /></Link> Company Subscription </h2>
            {!check && subs_amount==null?
              <Row  className="margb20px">
                <Col md={12}>
                  <div className="alert alert-danger company-subscription-alert" role="alert">
                      Your Dokkit subscription starts in {months} {days} days unless you cancel.
                  </div>
                </Col>
              </Row>
              : null
            }
            <p>
             Subscriptions are changed at the end of the billing period unless you are upgrading then they are effective immediately. For more information visit our <a href="http://www.dokkit.co.uk/Pricing" target="_blank">Pricing</a> page or contact <Link to="#" id="support2" onClick={this.openSupportPopup}>Support</Link>.
            </p>
          </div>
          <div className="plans-summery">
            <Row>
              <Col md={7}>
                <div className="plan-anually">
                  <Row>
                    <Col md={6}>
                      <div className="subscription-plan-list anually">
                        <div className="subscription-content">
                          <h3>Annually</h3>
                          {YearlyPlans}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="subscription-plan-list monthly">
                        <div className="subscription-content">
                          <h3>Monthly</h3>
                          {monthlyPlans}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={5}>
                <div className="plans-annual">
                  <div className="subscription-plan-list">
                    <h3>Plan Summary</h3>
                  </div>
                  {selectedPlan}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <Dialog 
        actions={action}
        className="model-support"
        modal={false}
        contentClassName="model-top-overlay no-overlay"
        open={ this.state.modalIsOpen}
        onRequestClose={this.closeModal}
      > 
            
          <div className="other-popup-content learn-more-popup">
              <form className="import-job-modal" >
              <h2 >{this.props.subscriptionPlan.upgradeDowngradeText}</h2>

              </form>
          </div>
      </Dialog>
      <Dialog
        title={this.state.popHeading}
        actions={[
                <FlatButton
                  label="Cancel"
                  primary={true}
                  onClick={this._closeModal}
                  keyboardFocused={true}
                />,
              ]}
        modal={true}
        open={this.state.openPop}
      >
        <br />
        <p>{this.state.popupMessage}</p>
        <br />
      </Dialog>
    </div>
    
    )
  }
}

const mapStateToProps = (state, props) => {
  // console.log("here ist the subscription data:=> ", state.subscription)
  return {
    subscriptionPlan: state.subscription,
    userDetail: state.login,
    currentuser : state.login
  }
};

const mapActionToProps = {
  fetchSubscriptionsRequest: fetchAllSubscriptions,
  selectedSubscription: selectSubscription,
  setTncText: toggleTncError,
  setCompanySubscription: setCompanySubscription,
  resetCompanySubscription: resetCompanySubscription,
  setSubscriptionUpdate:setSubscriptionUpdate,
  fetchLoginUserDetail: fetchLoginUserDetail,
  openSupportPopupSubscription: openSupportPopup,
  resetSubscriptionPlan: resetSubscriptionPlan,
  updateFromFreetrial: updateFromFreetrial
};

export default connect(mapStateToProps, mapActionToProps)(injectStripe(SubscriptionPlan));





// WEBPACK FOOTER //
// ./src/Components/Pages/SubscriptionPlan.js